import { Button, Grid, TextField } from "@mui/material";
import { LabelWithControl } from "components/common/LabelControl";

export const MultiPinSearch = ({
  packIds,
  setPackIds,
  searchError,
  onSearch,
  onAddNew,
  onUpdateAll,
  onDelete,
  mode,
}) => {
  if (mode === "pin") {
    return (
      <Grid item xs={12} sm={3} md={2}>
        <LabelWithControl label="PIN" labelId="packIds" required>
          <TextField
            id="packIds"
            variant="outlined"
            size="small"
            placeholder="Max 10 comma separated Pins"
            value={packIds}
            onChange={(e) => {
              const val = e.target.value.replace(/[^0-9,]/g, "");
              const parts = val.split(",");
              if (parts.every((p) => p.length <= 9))
                setPackIds(val);
            }}
            error={!!searchError}
            helperText={searchError}
            FormHelperTextProps={{
              style: { position: "absolute", bottom: "-18px" },
            }}
            fullWidth
          />
        </LabelWithControl>
      </Grid>
    );
  }
  return (
    <>
      <Grid item xs={6} sm={2} md={1}>
        <LabelWithControl labelVisible="hidden" label="Search">
          <Button
            variant="contained"
            color="primary"
            sx={{
              width: "-webkit-fill-available",
              height: "25px",
              fontSize: "12px",
            }}
            onClick={onSearch}
            fullWidth
          >
            Search
          </Button>
        </LabelWithControl>
      </Grid>
      <Grid item xs={6} sm={2} md={1.5}>
        <LabelWithControl labelVisible="hidden" label="Add">
          <Button
            variant="contained"
            color="primary"
            sx={{
              width: "-webkit-fill-available",
              height: "25px",
              fontSize: "12px",
            }}
            onClick={onAddNew}
            fullWidth
          >
            Add New PIN
          </Button>
        </LabelWithControl>
      </Grid>
      <Grid item xs={6} sm={2} md={1.5}>
        <LabelWithControl labelVisible="hidden" label="Update All">
          <Button
            variant="contained"
            color="primary"
            sx={{
              width: "-webkit-fill-available",
              height: "25px",
              fontSize: "12px",
            }}
            onClick={onUpdateAll}
            fullWidth
          >
            Bulk Update
          </Button>
        </LabelWithControl>
      </Grid>
      <Grid item xs={6} sm={2} md={1.5}>
        <LabelWithControl labelVisible="hidden" label="Delete">
          <Button
            variant="contained"
            color="error"
            sx={{
              width: "-webkit-fill-available",
              height: "25px",
              fontSize: "12px",
            }}
            onClick={onDelete}
            fullWidth
          >
            Bulk Delete
          </Button>
        </LabelWithControl>
      </Grid>
    </>
  );
};
